import React from "react";
import { Checkbox, Paragraph } from "_styleguide";
import { useSettings } from "_contexts/useSettings";
import { flatMoney, hexToRgba } from "_assets/js/helpers";
import { isDarkColor } from "_helpers/colors";
import "./CreditItem.scss";

function CreditItem(props) {
  const { settings } = useSettings();
  const { item } = props;

  const primaryColor = settings?.primary_color || "#0f766e";
  const primaryFontColor = isDarkColor(primaryColor) ? "#fff" : "#000";

  return (
    <div
      className={`credit-select-item ${item.selected ? "selected" : ""}`}
      key={`credit-select-item-${item.id}`}
      onClick={() => props.toggleTradeline(item.id)}
      style={{
        "--credit-item-selected-color": hexToRgba(
          settings?.primary_color || "#0f766e",
          0.5
        ),
      }}
    >
      <Checkbox
        checked={item.selected}
        style={{
          "--checkbox-color": primaryColor,
          "--checkbox-font-color": primaryFontColor,
        }}
      />
      <div className="credit-select-item-title">
        <Paragraph>{item.tradeline.customerName}</Paragraph>
        <Paragraph opacity={0.5}>
          ****{item.tradeline.accountNumber?.slice(0, 4)}
        </Paragraph>
      </div>
      <div className="credit-select-item-amount">
        <Paragraph>{flatMoney(item.tradeline.balanceAmount)}</Paragraph>
      </div>
    </div>
  );
}

export default CreditItem;
